import * as React from 'react';

const SectionJustifyFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="section-justify-fill_svg__eds-icon--section-justify-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="section-justify-fill_svg__eds-icon--section-justify-fill_base"
            fill="#010101"
            d="M4 20h16v-4H4v4z"
        />
        <path
            id="section-justify-fill_svg__eds-icon--section-justify-fill_middle"
            fill="#010101"
            d="M4 10v4h16v-4H4z"
        />
        <path
            id="section-justify-fill_svg__eds-icon--section-justify-fill_top"
            fill="#010101"
            d="M4 4v4h16V4H4z"
        />
    </svg>
);

SectionJustifyFillSvg.displayName = 'SectionJustifyFillSvg';
export default SectionJustifyFillSvg;
